import { formatDate, formatTime, prettyValue } from "../../js/utils/formatters";

export default function DashboardAlerts({ alerts = [], onDismiss }) {
  if (!alerts.length) return null;

  return (
    <section className="dashboard-alerts" aria-live="polite">
      <h2 className="section-title">Dashboard Alerts</h2>
      {alerts.map((alert) => (
        <article key={alert.id} className="dashboard-alert">
          <div>
            <strong>{alert.title}</strong>
            <div className="muted">
              {prettyValue(alert.type)} · {formatDate(alert.date)} {formatTime(alert.time)} · reminder{" "}
              {alert.reminder?.amount} {alert.reminder?.unit}
            </div>
          </div>
          <button type="button" className="ghost-btn" onClick={() => onDismiss?.(alert.id)}>
            Dismiss
          </button>
        </article>
      ))}
    </section>
  );
}
